import React, { ReactElement } from "react"
import { RoutingInfo } from "../../types/RoutingInfo"
import { Question, SubHeader } from "../../utils/RoutingInfoStyles"
import { AccordionPanel, AccordionItem } from "@chakra-ui/react"
import { AccordionItemHeader, AccordionSection } from "./Accordion"
import JourneyInfoDetail from "./JourneyInfoDetail"
import { AdditionalInfoQuestionKey } from "../../utils/RoutingInfoQuestionKey"
import Moment from "moment"
import { AnythingElseJourneyAnswer } from "./AnythingElseAnswer"
import MedicalInfoDetail from "./MedicalInfoDetail"

export default function PastRoutingAnswers({ pastRoutingInfo }: { pastRoutingInfo: RoutingInfo[] }): ReactElement {
  return (
    <AccordionSection isDefaultOpen={false}>
      <AccordionItem borderBottom={"0px"}>
        {({ isExpanded }) => (
          <>
            <AccordionItemHeader>
              <SubHeader>{isExpanded ? "Hide previous routing answers" : "View previous routing answers"}</SubHeader>
            </AccordionItemHeader>
            <AccordionPanel padding={"0px"}>
              <PastRoutingDetail pastRoutingInfo={pastRoutingInfo} />
            </AccordionPanel>
          </>
        )}
      </AccordionItem>
    </AccordionSection>
  )
}

function PastRoutingDetail({ pastRoutingInfo }: { pastRoutingInfo: RoutingInfo[] }): ReactElement {
  return (
    <AccordionSection isDefaultOpen={false}>
      {pastRoutingInfo.map((routingInfo: RoutingInfo, index: number) => (
        <AccordionItem id={routingInfo?.routingInfoId.toString()} key={routingInfo?.routingInfoId} borderBottom={"0px"}>
          <AccordionItemHeader>
            <Question>{"Completed " + Moment(routingInfo?.routingCompletedDate).format("l")}</Question>
          </AccordionItemHeader>
          <AccordionPanel padding={"0px"}>
            <JourneyInfoDetail routingInfo={routingInfo} previousRoutingInfo={pastRoutingInfo[index + 1]} />
            <MedicalInfoDetail allMedicalInfo={routingInfo.allMedicalInfo} />
            <AnythingElseJourneyAnswer
              subHeader={"Additional information from routing"}
              questionKey={AdditionalInfoQuestionKey.MemberJourneyAdditionalInfo}
              skipFields={routingInfo?.skipFields}
              answer={routingInfo?.memberJourneyAdditionalInfo}
              additionalTopicsShared={routingInfo?.additionalTopicsShared}
            />
          </AccordionPanel>
        </AccordionItem>
      ))}
    </AccordionSection>
  )
}
